 export const dns = 'https://digiapp.nrfsi.com',
//  export const dns = 'https://digiappuat.nrfsi.com',


//    baseUrl = `${dns}/nrfsi/nissan/`, // prod
//  baseUrl = `${dns}/nrfsi/preprod/`, // preprod
// export const dns = 'http://65.108.211.159:9090',

    baseUrl = `${dns}/nrfsi/nissan/`, // prod
    // baseUrl = `${dns}/nrfsi/qa/`, // prod
    nissanUrl = `${dns}/dlp`,
    preprodUrl = `${dns}/dlp_preprod/login`;

export const environment = {

    production: true,

    apiURL: {
        env: `${baseUrl}`,
        nUrl: `${nissanUrl}`,
        preUrl: `${preprodUrl}`,
        saveInfo: `${baseUrl}applicant/info`,
        saveIncome: `${baseUrl}applicant/income`,
        // saveLoan: `${baseUrl}finance/loan`,
        financialProductDetails: `${baseUrl}finance/details`,
        fetchVehicleDetails: `${baseUrl}asset/details/`,
        fetchQuotationStatus: `${baseUrl}quotation/status`,
        quoteCreation: `${baseUrl}asset/newQuote`,
        searchQuote: `${baseUrl}quotation/search`,
        generateOtp: `${baseUrl}applicant/consent`,
        sendOtp: `${baseUrl}applicant/consent/check`,
        resendOtp: `${baseUrl}applicant/consent/resend`,
        generateOtpToVerifyMobileEmail: `${baseUrl}applicant/consent/send/mobile/email`,
        sendOtpToVerifyMobileEmail: `${baseUrl}applicant/consent/check/mobile/email`,
        resendOtpToVerifyMobileEmail: `${baseUrl}applicant/consent/resend/mobile/email`,
        login: `${baseUrl}dlp/dealer/login`,
        fetchBackForm: `${baseUrl}`,
        addressDetails: `${baseUrl}locality/pincode`,
        dropdown: `${baseUrl}applicant/autofill`,
        financialProduct: `${baseUrl}financeService/financeproducts`,
        specialProgram: `${baseUrl}financeService/financeprograms`,
        loanStep1Post: `${baseUrl}finance/prodInfo`,
        loanStep2Post: `${baseUrl}finance/loan`, // to save the loan terms details + status
        refId: `${baseUrl}finance/loan/refid`, // to get the indus ref id
        emi: `${baseUrl}finance/loan/emi`,
        getSubventionDetails: `${baseUrl}finance/subvention/details`,
        subvention: `${baseUrl}finance/subvention`,
        subventionEmi: `${baseUrl}finance/subvention/emi`,
        subproductsEmi: `${baseUrl}finance/subproduct/emi`,
        subproducts: `${baseUrl}finance/subproducts`,
        changeCreation: `${baseUrl}asset/changeQuote`,
        loanReset: `${baseUrl}applicant/quotation`,
        preview: `${baseUrl}review/info/`,
        trackQuote: `${baseUrl}application/status/`,
        recentActivities: `${baseUrl}quotation/searchLastFive`,
        notification: `${baseUrl}notifications/preApproval`,
        deleteNotifiaction: `${baseUrl}notifications/updateReadStatus`,
        getFinanceDescription: `${baseUrl}financeService/selectedFinDet`,
        trackDistinct: `${baseUrl}quotation/track`, // for seach in track page
        approvalList: `${baseUrl}preapproval/status`,
        docsUpload: `${baseUrl}upload/doc`,
        viewDoc: `${baseUrl}upload/viewDoc`,
        trackDocQuote: `${baseUrl}docSearch/status/`,
        validatePAN: `${baseUrl}dlp/dealer/pan/validate`,
        logout: `${baseUrl}dlp/dealer/logout`,

        // generateCaptcha:  `${baseUrl}dlp/captcha/generate`,
        // validateCaptcha:  `${baseUrl}dlp/captcha/validate`,

    }

};
